import axiosConfig from '../utils/axiosConfig';

export interface ProductPriceWarehouse {
  _id: string;
  warehouse: {
    _id: string;
    name: string;
    location?: string;
  };
  warehouseName: string;
  price: number;
  cost: number;
  lastUpdated: string;
}

export interface ProductPricesReportItem {
  _id: string;
  product: {
    _id: string;
    name: string;
    status: string;
  };
  productName: string;
  variantId: string;
  variantSerialNumber: number;
  variantAttributes: Record<string, string>;
  barcode: string;
  sku?: string;
  unit: string;
  categories: Array<{
    _id: string;
    name: string;
  }>;
  warehousePrices: ProductPriceWarehouse[];
  defaultBarcode?: {
    unit?: string;
    retailPrice?: number;
    wholesalePrice?: number;
    customPrice1?: number;
    customPrice2?: number;
    lastCost?: number;
    averageCost?: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ProductPricesReportFilters {
  page?: number;
  limit?: number;
  search?: string;
  category?: string;
  warehouse?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface ProductPricesReportResponse {
  success: boolean;
  data: ProductPricesReportItem[];
  pagination: {
    current: number;
    pages: number;
    total: number;
    limit: number;
  };
}

export interface Warehouse {
  _id: string;
  name: string;
  location?: string;
}

export interface Category {
  _id: string;
  name: string;
}

export interface WarehousesResponse {
  success: boolean;
  data: Warehouse[];
}

export interface CategoriesResponse {
  success: boolean;
  data: Category[];
}

class ProductPricesReportService {
  private baseURL = '/product-prices-report';

  async getProductPricesReport(filters: ProductPricesReportFilters = {}): Promise<ProductPricesReportResponse> {
    try {
      const params = new URLSearchParams();
      
      if (filters.page) params.append('page', filters.page.toString());
      if (filters.limit) params.append('limit', filters.limit.toString());
      if (filters.search) params.append('search', filters.search);
      if (filters.category) params.append('category', filters.category);
      if (filters.warehouse) params.append('warehouse', filters.warehouse);
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

      console.log('جلب تقرير أسعار المنتجات من:', `${this.baseURL}?${params.toString()}`);
      const response = await axiosConfig.get(`${this.baseURL}?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product prices report:', error);
      console.log('يحتاج إنشاء API endpoint في الخادم:', this.baseURL);
      throw error;
    }
  }

  async getWarehouses(): Promise<WarehousesResponse> {
    try {
      const response = await axiosConfig.get(`${this.baseURL}/warehouses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching warehouses:', error);
      console.log('يحتاج إنشاء API endpoint في الخادم:', `${this.baseURL}/warehouses`);
      throw error;
    }
  }

  async getCategories(): Promise<CategoriesResponse> {
    try {
      const response = await axiosConfig.get(`${this.baseURL}/categories`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      console.log('يحتاج إنشاء API endpoint في الخادم:', `${this.baseURL}/categories`);
      throw error;
    }
  }
}

const productPricesReportService = new ProductPricesReportService();
export default productPricesReportService;
